import { Action, ActionReducer, ActionReducerMap, combineReducers, createFeatureSelector, createSelector, MetaReducer } from '@ngrx/store';
import * as fromLegalEntitiesList from './legal-entities-list.reducer';
import * as fromLegalEntitiesHierarchy from './legal-entities-hierarchy.reducer';
import * as fromLeProductSolution from './le-product-solution.reducer';
import * as fromProductSolutionsForProduct from './product-solutions-for-product.reducer';

import * as fromManageOfferings from './get-manage-offerings.reducer';
import * as fromPFSettings from './get-pf-settings.reducer';
import * as fromAgeDistributionChart from './get-age-distribution-chart.reducer';
import * as fromFundCreditByAgeChart from './get-fund-credit-by-age-chart.reducer';
import * as fromContributionsByAgeChart from './get-contributions-by-age-chart.reducer';
import * as fromFundingStatusDistributionChart from './get-funding-status-distribution-chart.reducer';
import * as fromFundingStatusByAgeBarChart from './get-funding-status-by-age-bar-chart.reducer';
import * as fromFundingStatusByAgeScatterChart from './get-funding-status-by-age-scatter-chart.reducer';
import * as fromRequiredincreaseInContributionsBarChart from './get-required-increase-in-contributions-bar-chart.reducer';
import * as fromRequiredincreaseInContributionsScatterChart from './get-required-increase-in-contributions-scatter-chart.reducer';
import * as fromPFSettingsCurrentFile from './get-pf-settings-current-file.reducer';
import * as fromPFSettingsPreviousFiles from './get-pf-settings-previous-file.reducer';
import * as fromAVCFrequencyLookups from './get-avc-frequency-lookups.reducer';
import * as fromGetSavedProductSolutions from './save-all-product-solutions.reducer';
import * as fromGetBulkImportEmployees from './bulk-upload-employees.reducer';
import * as fromGetBulkEmployeesUpdateHistory from './bulk-employees-update-history.reducer';
import * as fromAssetManagerViewLinkedBusinesses from './asset-manager-view-linked-businesses.reducer';
import * as fromBusinessViewLinkedAssetManager from './business-view-linked-asset-manager.reducer';
import * as fromAcceptBulkEmployeeUpdatesReducer from '../reducers/accept-bulk-employee-updates.reducer';
import * as fromSendBulkEmployeeInviteReducer from '../reducers/send-bulk-employee-invite.reducer';
import * as fromSendSelectedEmployeeInviteReducer from '../reducers/send-selected-employee-invite.reducer';
import * as fromAcceptSelectedEmployeeUpdatesReducer from '../reducers/accept-selected-employee-updates.reducer';
import * as fromAcceptBulkEmployeeUpdatesSendInvitesReducer from '../reducers/accept-bulk-employee-updates-send-invites.reducer';
import * as fromGetBulkEmployeeUpdateFromExcelsStatusReducer from './get-bulk-employee-update-from-excels-status.reducer';
import * as fromUndoSelectedEmployeeUpdatesReducer from '../reducers/undo-selected-employee-updates.reducer';
import * as fromUndoBulkEmployeeUpdatesReducer from '../reducers/undo-bulk-employee-updates.reducer';
import * as fromGetBusinessReducer from './get-business.reducer';
import * as fromGetManageUsersSetupReducer from './get-manage-users-setup.reducer';
import * as fromUpdateUpdatedUserReducer from './update-updated-user.reducer';
import * as fromUpdateUpdatedProductReducer from './update-updated-product.reducer';
import * as fromUpdateNewUserReducer from './update-new-user.reducer';
import * as fromUpdateNewProductReducer from './update-new-product.reducer';

export const legalEntitiesFeatureKey = 'legalEntities';

export interface LegalEntitiesState {
  [fromLegalEntitiesList.legalEntitiesListFeatureKey]: fromLegalEntitiesList.LegalEntitiesListState;
  [fromLegalEntitiesHierarchy.legalEntitiesHierarchyFeatureKey]: fromLegalEntitiesHierarchy.LegalEntitiesHierarchyState;
  [fromLeProductSolution.leProductSolutionFeatureKey]: fromLeProductSolution.LeProductSolutionState;
  [fromProductSolutionsForProduct.productSolutionsForProductFeatureKey]: fromProductSolutionsForProduct.ProductSolutionsForProductState;
  [fromManageOfferings.getManageOfferingsFeatureKey]: fromManageOfferings.ManageOfferingsState;
  [fromPFSettings.getPFSettingsFeatureKey]: fromPFSettings.PFSettingsState;
  [fromAgeDistributionChart.getAgeDistributionChartKey]: fromAgeDistributionChart.AgeDistributionChartState;
  [fromFundCreditByAgeChart.getFundCreditByAgeChartKey]: fromFundCreditByAgeChart.FundCreditByAgeChartState;
  [fromContributionsByAgeChart.getContributionsByAgeChartKey]: fromContributionsByAgeChart.ContributionsByAgeChartState;
  [fromFundingStatusDistributionChart.getFundingStatusDistributionChartKey]: fromFundingStatusDistributionChart.FundingStatusDistributionChartState;
  [fromFundingStatusByAgeBarChart.getFundingStatusByAgeBarChartKey]: fromFundingStatusByAgeBarChart.FundingStatusByAgeBarChartState;
  [fromFundingStatusByAgeScatterChart.getFundingStatusByAgeScatterChartKey]: fromFundingStatusByAgeScatterChart.FundingStatusByAgeScatterChartState;
  [fromRequiredincreaseInContributionsBarChart.getRequiredIncreaseInContributionsBarChartKey]: fromRequiredincreaseInContributionsBarChart.RequiredIncreaseInContributionsBarChartState;
  [fromRequiredincreaseInContributionsScatterChart.getRequiredIncreaseInContributionsScatterChartKey]: fromRequiredincreaseInContributionsScatterChart.RequiredIncreaseInContributionsScatterChartState;
  [fromPFSettingsCurrentFile.getPFSettingsCurrentFileFeatureKey]: fromPFSettingsCurrentFile.PFSettingsCurrentFileState;
  [fromPFSettingsPreviousFiles.getPFSettingsPreviousFileFeatureKey]: fromPFSettingsPreviousFiles.PFSettingsPreviousFileState;
  [fromAVCFrequencyLookups.getAVCFrequencyLookupsFeatureKey]: fromAVCFrequencyLookups.AVCFrequencyLookupsState;
  [fromGetBusinessReducer.getBusinessKey]: fromGetBusinessReducer.GetBusinessState;
  [fromGetBulkImportEmployees.getBulkImportEmployeesDataKey]: fromGetBulkImportEmployees.State;
  [fromGetBulkEmployeesUpdateHistory.getBulkEmployeesUpdateHistoryKey]: fromGetBulkEmployeesUpdateHistory.State;
  [fromGetSavedProductSolutions.saveAllProductSolutionsFeatureKey]: fromGetSavedProductSolutions.saveProductSolutionsState;
  [fromAssetManagerViewLinkedBusinesses.assetManagerViewLinkedBusinessesFeatureKey]: fromAssetManagerViewLinkedBusinesses.AssetManagerViewLinkedBusinessesState;
  [fromBusinessViewLinkedAssetManager.businessViewLinkedAssetManagerFeatureKey]: fromBusinessViewLinkedAssetManager.BusinessViewLinkedAssetManagerState;
  [fromAcceptBulkEmployeeUpdatesReducer.acceptBulkEmployeeUpdatesKey]: fromAcceptBulkEmployeeUpdatesReducer.AcceptBulkEmployeeUpdatesState;
  [fromAcceptBulkEmployeeUpdatesSendInvitesReducer.acceptBulkEmployeeUpdatesAndSendInvitesKey]: fromAcceptBulkEmployeeUpdatesSendInvitesReducer.AcceptBulkEmployeeUpdatesAndSendInvitesState;
  [fromSendBulkEmployeeInviteReducer.sendBulkEmployeeInviteKey]: fromSendBulkEmployeeInviteReducer.SendBulkEmployeeInviteState;
  [fromSendSelectedEmployeeInviteReducer.sendSelectedEmployeeInviteKey]: fromSendSelectedEmployeeInviteReducer.SendSelectedEmployeeInviteState;
  [fromAcceptSelectedEmployeeUpdatesReducer.acceptSelectedEmployeeUpdatesKey]: fromAcceptSelectedEmployeeUpdatesReducer.AcceptSelectedEmployeeUpdatesState;
  [fromUndoSelectedEmployeeUpdatesReducer.undoSelectedEmployeeUpdatesKey]: fromUndoSelectedEmployeeUpdatesReducer.UndoSelectedEmployeeUpdatesState;
  [fromUndoBulkEmployeeUpdatesReducer.undoBulkEmployeeUpdatesKey]: fromUndoBulkEmployeeUpdatesReducer.UndoBulkEmployeeUpdatesState;
  [fromGetBulkEmployeeUpdateFromExcelsStatusReducer.getBulkEmployeeUpdateFromExcelsStatusKey]: fromGetBulkEmployeeUpdateFromExcelsStatusReducer.BulkEmployeeUpdateFromExcelsStatusState;
  [fromGetManageUsersSetupReducer.getManageUsersSetupKey]: fromGetManageUsersSetupReducer.GetManageUsersSetupState;
  [fromUpdateUpdatedUserReducer.updateUpdatedUserKey]: fromUpdateUpdatedUserReducer.UpdateUpdatedUserState;
  [fromUpdateUpdatedProductReducer.updateUpdatedProductKey]: fromUpdateUpdatedProductReducer.UpdateUpdatedProductState;
  [fromUpdateNewUserReducer.updateNewUserKey]: fromUpdateNewUserReducer.UpdateNewUserState;
  [fromUpdateNewProductReducer.updateNewProductKey]: fromUpdateNewProductReducer.UpdateNewProductState;
}

export interface State {
  [legalEntitiesFeatureKey]: LegalEntitiesState;
}

export function reducers(state: LegalEntitiesState | undefined, action: Action) {
  return combineReducers({
    [fromLegalEntitiesList.legalEntitiesListFeatureKey]: fromLegalEntitiesList.reducer,
    [fromLegalEntitiesHierarchy.legalEntitiesHierarchyFeatureKey]: fromLegalEntitiesHierarchy.reducer,
    [fromLeProductSolution.leProductSolutionFeatureKey]: fromLeProductSolution.reducer,
    [fromProductSolutionsForProduct.productSolutionsForProductFeatureKey]: fromProductSolutionsForProduct.reducer,
    [fromManageOfferings.getManageOfferingsFeatureKey]: fromManageOfferings.reducer,
    [fromPFSettings.getPFSettingsFeatureKey]: fromPFSettings.reducer,
    [fromAgeDistributionChart.getAgeDistributionChartKey]: fromAgeDistributionChart.reducer,
    [fromFundCreditByAgeChart.getFundCreditByAgeChartKey]: fromFundCreditByAgeChart.reducer,
    [fromContributionsByAgeChart.getContributionsByAgeChartKey]: fromContributionsByAgeChart.reducer,
    [fromFundingStatusDistributionChart.getFundingStatusDistributionChartKey]: fromFundingStatusDistributionChart.reducer,
    [fromFundingStatusByAgeBarChart.getFundingStatusByAgeBarChartKey]: fromFundingStatusByAgeBarChart.reducer,
    [fromFundingStatusByAgeScatterChart.getFundingStatusByAgeScatterChartKey]: fromFundingStatusByAgeScatterChart.reducer,
    [fromRequiredincreaseInContributionsBarChart.getRequiredIncreaseInContributionsBarChartKey]:
      fromRequiredincreaseInContributionsBarChart.reducer,
    [fromRequiredincreaseInContributionsScatterChart.getRequiredIncreaseInContributionsScatterChartKey]:
      fromRequiredincreaseInContributionsScatterChart.reducer,
    [fromPFSettingsCurrentFile.getPFSettingsCurrentFileFeatureKey]: fromPFSettingsCurrentFile.reducer,
    [fromPFSettingsPreviousFiles.getPFSettingsPreviousFileFeatureKey]: fromPFSettingsPreviousFiles.reducer,
    [fromAVCFrequencyLookups.getAVCFrequencyLookupsFeatureKey]: fromAVCFrequencyLookups.reducer,
    [fromGetSavedProductSolutions.saveAllProductSolutionsFeatureKey]: fromGetSavedProductSolutions.reducer,
    [fromGetBulkImportEmployees.getBulkImportEmployeesDataKey]: fromGetBulkImportEmployees.reducer,
    [fromGetBulkEmployeesUpdateHistory.getBulkEmployeesUpdateHistoryKey]: fromGetBulkEmployeesUpdateHistory.reducer,
    [fromAcceptBulkEmployeeUpdatesReducer.acceptBulkEmployeeUpdatesKey]: fromAcceptBulkEmployeeUpdatesReducer.reducer,
    [fromAcceptBulkEmployeeUpdatesSendInvitesReducer.acceptBulkEmployeeUpdatesAndSendInvitesKey]:
      fromAcceptBulkEmployeeUpdatesSendInvitesReducer.reducer,
    [fromSendBulkEmployeeInviteReducer.sendBulkEmployeeInviteKey]: fromSendBulkEmployeeInviteReducer.reducer,
    [fromSendSelectedEmployeeInviteReducer.sendSelectedEmployeeInviteKey]: fromSendSelectedEmployeeInviteReducer.reducer,
    [fromAcceptSelectedEmployeeUpdatesReducer.acceptSelectedEmployeeUpdatesKey]: fromAcceptSelectedEmployeeUpdatesReducer.reducer,
    [fromUndoSelectedEmployeeUpdatesReducer.undoSelectedEmployeeUpdatesKey]: fromUndoSelectedEmployeeUpdatesReducer.reducer,
    [fromUndoBulkEmployeeUpdatesReducer.undoBulkEmployeeUpdatesKey]: fromUndoBulkEmployeeUpdatesReducer.reducer,
    [fromAssetManagerViewLinkedBusinesses.assetManagerViewLinkedBusinessesFeatureKey]: fromAssetManagerViewLinkedBusinesses.reducer,
    [fromBusinessViewLinkedAssetManager.businessViewLinkedAssetManagerFeatureKey]: fromBusinessViewLinkedAssetManager.reducer,
    [fromGetBulkEmployeeUpdateFromExcelsStatusReducer.getBulkEmployeeUpdateFromExcelsStatusKey]:
      fromGetBulkEmployeeUpdateFromExcelsStatusReducer.reducer,
    [fromGetBusinessReducer.getBusinessKey]: fromGetBusinessReducer.reducer,
    [fromGetManageUsersSetupReducer.getManageUsersSetupKey]: fromGetManageUsersSetupReducer.reducer,
    [fromUpdateUpdatedUserReducer.updateUpdatedUserKey]: fromUpdateUpdatedUserReducer.reducer,
    [fromUpdateUpdatedProductReducer.updateUpdatedProductKey]: fromUpdateUpdatedProductReducer.reducer,
    [fromUpdateNewUserReducer.updateNewUserKey]: fromUpdateNewUserReducer.reducer,
    [fromUpdateNewProductReducer.updateNewProductKey]: fromUpdateNewProductReducer.reducer
  })(state, action);
}

export const selectRootLegalEntitiesState = createFeatureSelector<State, LegalEntitiesState>(legalEntitiesFeatureKey);

export const getLegalEntitiesListState = createSelector(
  selectRootLegalEntitiesState,
  state => state[fromLegalEntitiesList.legalEntitiesListFeatureKey]
);

export const getLegalEntitiesHierarchyState = createSelector(
  selectRootLegalEntitiesState,
  state => state[fromLegalEntitiesHierarchy.legalEntitiesHierarchyFeatureKey]
);

export const getLegalEntitiesProductSolutions = createSelector(
  selectRootLegalEntitiesState,
  state => state[fromLeProductSolution.leProductSolutionFeatureKey]
);

export const getLegalEntitiesProductSoltionsForProduct = createSelector(
  selectRootLegalEntitiesState,
  state => state[fromProductSolutionsForProduct.productSolutionsForProductFeatureKey]
);

export const getManageOfferingsState = createSelector(
  selectRootLegalEntitiesState,
  state => state[fromManageOfferings.getManageOfferingsFeatureKey]
);

export const getPFSettingsState = createSelector(selectRootLegalEntitiesState, state => state[fromPFSettings.getPFSettingsFeatureKey]);

export const getAgeDistributionChartState = createSelector(
  selectRootLegalEntitiesState,
  state => state[fromAgeDistributionChart.getAgeDistributionChartKey]
);

export const getFundCreditByAgeChartState = createSelector(
  selectRootLegalEntitiesState,
  state => state[fromFundCreditByAgeChart.getFundCreditByAgeChartKey]
);

export const getContributionsByAgeChartState = createSelector(
  selectRootLegalEntitiesState,
  state => state[fromContributionsByAgeChart.getContributionsByAgeChartKey]
);

export const getFundingStatusDistributionChartState = createSelector(
  selectRootLegalEntitiesState,
  state => state[fromFundingStatusDistributionChart.getFundingStatusDistributionChartKey]
);

export const getFundingStatusByAgeBarChartState = createSelector(
  selectRootLegalEntitiesState,
  state => state[fromFundingStatusByAgeBarChart.getFundingStatusByAgeBarChartKey]
);

export const getFundingStatusByAgeScatterChartState = createSelector(
  selectRootLegalEntitiesState,
  state => state[fromFundingStatusByAgeScatterChart.getFundingStatusByAgeScatterChartKey]
);

export const getRequiredincreaseInContributionsBarChartState = createSelector(
  selectRootLegalEntitiesState,
  state => state[fromRequiredincreaseInContributionsBarChart.getRequiredIncreaseInContributionsBarChartKey]
);

export const getRequiredincreaseInContributionsScatterChartState = createSelector(
  selectRootLegalEntitiesState,
  state => state[fromRequiredincreaseInContributionsScatterChart.getRequiredIncreaseInContributionsScatterChartKey]
);

export const getPFSettingsCurrentFileState = createSelector(
  selectRootLegalEntitiesState,
  state => state[fromPFSettingsCurrentFile.getPFSettingsCurrentFileFeatureKey]
);

export const getPFSettingsPreviousFileState = createSelector(
  selectRootLegalEntitiesState,
  state => state[fromPFSettingsPreviousFiles.getPFSettingsPreviousFileFeatureKey]
);

export const getAVCFrequencyLookupsState = createSelector(
  selectRootLegalEntitiesState,
  state => state[fromAVCFrequencyLookups.getAVCFrequencyLookupsFeatureKey]
);

export const GetSavedProductSolutionsState = createSelector(
  selectRootLegalEntitiesState,
  state => state[fromGetSavedProductSolutions.saveAllProductSolutionsFeatureKey]
);

export const GetBulkImportEmployeesState = createSelector(
  selectRootLegalEntitiesState,
  state => state[fromGetBulkImportEmployees.getBulkImportEmployeesDataKey]
);

export const BulkEmployeesUpdateHistoryState = createSelector(
  selectRootLegalEntitiesState,
  state => state[fromGetBulkEmployeesUpdateHistory.getBulkEmployeesUpdateHistoryKey]
);

export const getAssetManagerViewLinkedBusinessesState = createSelector(
  selectRootLegalEntitiesState,
  state => state[fromAssetManagerViewLinkedBusinesses.assetManagerViewLinkedBusinessesFeatureKey]
);

export const getBusinessViewLinkedAssetManagerState = createSelector(
  selectRootLegalEntitiesState,
  state => state[fromBusinessViewLinkedAssetManager.businessViewLinkedAssetManagerFeatureKey]
);

export const acceptBulkEmployeeUpdatesState = createSelector(
  selectRootLegalEntitiesState,
  state => state[fromAcceptBulkEmployeeUpdatesReducer.acceptBulkEmployeeUpdatesKey]
);

export const acceptBulkEmployeeUpdatesAndSendInvitesState = createSelector(
  selectRootLegalEntitiesState,
  state => state[fromAcceptBulkEmployeeUpdatesSendInvitesReducer.acceptBulkEmployeeUpdatesAndSendInvitesKey]
);

export const sendBulkEmployeeInviteState = createSelector(
  selectRootLegalEntitiesState,
  state => state[fromSendBulkEmployeeInviteReducer.sendBulkEmployeeInviteKey]
);

export const sendSelectedEmployeeInviteState = createSelector(
  selectRootLegalEntitiesState,
  state => state[fromSendSelectedEmployeeInviteReducer.sendSelectedEmployeeInviteKey]
);

export const acceptSelectedEmployeeUpdatesState = createSelector(
  selectRootLegalEntitiesState,
  state => state[fromAcceptSelectedEmployeeUpdatesReducer.acceptSelectedEmployeeUpdatesKey]
);

export const undoSelectedEmployeeUpdatesState = createSelector(
  selectRootLegalEntitiesState,
  state => state[fromUndoSelectedEmployeeUpdatesReducer.undoSelectedEmployeeUpdatesKey]
);

export const undoBulkEmployeeUpdatesState = createSelector(
  selectRootLegalEntitiesState,
  state => state[fromUndoBulkEmployeeUpdatesReducer.undoBulkEmployeeUpdatesKey]
);

export const GetBulkEmployeeUpdateFromExcelsStatusState = createSelector(
  selectRootLegalEntitiesState,
  state => state[fromGetBulkEmployeeUpdateFromExcelsStatusReducer.getBulkEmployeeUpdateFromExcelsStatusKey]
);

export const GetBusinessState = createSelector(selectRootLegalEntitiesState, state => state[fromGetBusinessReducer.getBusinessKey]);

export const GetManageUsersSetupState = createSelector(
  selectRootLegalEntitiesState,
  state => state[fromGetManageUsersSetupReducer.getManageUsersSetupKey]
);

export const GetUpdateUpdatedUserState = createSelector(
  selectRootLegalEntitiesState,
  state => state[fromUpdateUpdatedUserReducer.updateUpdatedUserKey]
);

export const GetUpdateUpdatedProductState = createSelector(
  selectRootLegalEntitiesState,
  state => state[fromUpdateUpdatedProductReducer.updateUpdatedProductKey]
);

export const GetUpdateNewUserState = createSelector(
  selectRootLegalEntitiesState,
  state => state[fromUpdateNewUserReducer.updateNewUserKey]
);

export const GetUpdateNewProductState = createSelector(
  selectRootLegalEntitiesState,
  state => state[fromUpdateNewProductReducer.updateNewProductKey]
);
